/**
 * Consultation and catalog dialogs (snippets/omi-help-dialogs.liquid).
 * The HubSpot scheduler and form load on first open only.
 */
(() => {
  const consult = /** @type {HTMLDialogElement | null} */ (document.getElementById('OmiConsultDialog'));
  const catalog = /** @type {HTMLDialogElement | null} */ (document.getElementById('OmiCatalogDialog'));
  if (!consult && !catalog) return;
  /** @type {HTMLElement | null} */ let opener = null;

  /** @param {HTMLDialogElement} dialog */
  const open = (dialog) => {
    opener = /** @type {HTMLElement | null} */ (document.activeElement);
    if (!dialog.open) dialog.showModal();
    if (dialog === consult) loadScheduler();
    if (dialog === catalog) loadForm();
  };

  const loadScheduler = () => {
    if (!consult) return;
    const frame = /** @type {HTMLIFrameElement} */ (consult.querySelector('iframe'));
    if (frame.src) return;
    frame.addEventListener('load', () => {
      frame.hidden = false;
      consult.querySelector('[data-omi-help-loading]')?.setAttribute('hidden', '');
    });
    frame.src = consult.dataset.src || '';
  };

  let formLoading = false;
  const loadForm = () => {
    if (!catalog || formLoading) return;
    formLoading = true;
    const create = () => {
      // @ts-ignore HubSpot global
      window.hbspt.forms.create({
        region: catalog.dataset.region,
        portalId: catalog.dataset.portal,
        formId: catalog.dataset.form,
        target: '#OmiCatalogForm',
        onFormReady: () => catalog.querySelector('[data-omi-help-loading]')?.setAttribute('hidden', ''),
      });
    };
    // @ts-ignore HubSpot global
    if (window.hbspt?.forms) return create();
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/v2.js';
    script.async = true;
    script.onload = create;
    document.head.appendChild(script);
  };

  for (const dialog of [consult, catalog]) {
    if (!dialog) continue;
    dialog.addEventListener('click', (event) => {
      const target = /** @type {HTMLElement} */ (event.target);
      if (target === dialog || target.closest('[data-omi-help-close]')) dialog.close();
    });
    dialog.addEventListener('close', () => opener?.focus?.());
  }

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey) return;
    const link = /** @type {HTMLElement | null} */ (
      /** @type {HTMLElement} */ (event.target).closest('a[href], [data-omi-consult], [data-omi-catalog]')
    );
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (consult && (link.hasAttribute('data-omi-consult') || href.includes('meetings.hubspot.com'))) {
      event.preventDefault();
      open(consult);
    } else if (catalog && (link.hasAttribute('data-omi-catalog') || href === '#catalog' || /\/pages\/catalog-request\b/.test(href))) {
      event.preventDefault();
      open(catalog);
    }
  });
})();
